import { render, staticRenderFns } from "./TruncateText.vue?vue&type=template&id=76623d6f&"
import script from "./TruncateText.vue?vue&type=script&lang=js&"
export * from "./TruncateText.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports